module.exports = __webpack_public_path__ + "img/inactive_passive.924ebe65.png";